import ReactDOM from 'react-dom/client';
import React from 'react';

import App from './app';

import './index.css';
import * as Sentry from '@sentry/react';
import {
	IS_PRODUCTION,
	SENTRY_DSN,
	ENV,
	VERSION,
	BUILD_SHA,
	IS_LOCAL,
} from '@config/constants/env.ts';
import {
	useLocation,
	useNavigationType,
	createRoutesFromChildren,
	matchRoutes,
} from 'react-router';

if (!IS_LOCAL) {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: ENV,
		release: IS_PRODUCTION
			? `iglu@${VERSION}`
			: `iglu@${VERSION}+${BUILD_SHA}`,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.browserTracingIntegration(),
		],
		// Performance Monitoring
		tracesSampleRate: 1.0,
		tracePropagationTargets: IS_PRODUCTION
			? [
					/^https:\/\/iglu\.inuk\.co/,
					/^https:\/\/v3-api\.inuk\.co/,
				]
			: [
					/^https:\/\/iglu-staging\.inuk\.co/,
					/^https:\/\/api-staging\.inuk\.co/,
				],
	});
}

ReactDOM.createRoot(
	document.getElementById('root')!
).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
